module.exports = __webpack_public_path__ + "static/img/Michael.Hurley.1f400c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael.Hurley.jpg
// module id = tjsy
// module chunks = 0